// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__sXdY6","alert":"SettungsInbox_alert__3jM8x"};